import {Paging} from 'helpers/constants';
import {invByLocationActionTypes as types} from 'actions/actionTypes';

const initialState = {
  allChecked: false,
  copyLoading: false,
  deleteLoading: false,
  isLoading: false,
  items: [],
  moveLoading: false,
  pageInfo: {
    pageNumber: 1,
    pageSize: Paging.initialPageSize,
    pageSizes: Paging.pageSizes,
  },
  selectedCount: 0,
  selectedLocationId: null,
  sortInfo: {
    sortColumn: 'name',
    sortOrder: 'Ascending',
  },
  summary: {},
  totalRows: 0,
  totalValue: 0,
};

export default function inventoryByLocation(state = initialState, action) {
  switch (action.type) {
    case types.GET_INV_ITEM_BY_LOCATION_ITEMS_SUCCESS: {
      return {
        ...state,
        items: [...action.items],
        allChecked: false,
        selectedCount: 0,
        isLoading: false,
        totalRows: action.totalRows,
      };
    }

    case types.INV_BY_LOCATION_PAGE_CHANGED:
      return {
        ...state,
        pageInfo: {
          ...state.pageInfo,
          pageSize: action.pageSize,
          pageNumber: action.pageNumber,
        },
      };

    case types.INV_BY_LOCATION_SORT_CHANGED:
      return {
        ...state,
        sortInfo: {
          sortOrder: action.sortOrder,
          sortColumn: action.sortColumn,
        },
      };

    case types.INV_BY_LOCATION_SELECTED_CHANGED:
      return {
        ...state,
        selectedLocationId: action.selectedLocationId,
        pageInfo: {
          ...state.pageInfo,
          pageNumber: 1,
        },
      };

    case types.INV_BY_LOCATION_ITEM_CHECK_CHANGED: {
      const {items} = state;
      const updatedItems = items.map(i => {
        return {
          ...i,
          isChecked: i.id === action.itemId ? !i.isChecked : i.isChecked,
        };
      });

      return {
        ...state,
        allChecked: false,
        selectedCount: updatedItems.filter(i => i.isChecked).length,
        items: updatedItems,
      };
    }

    case types.INV_BY_LOCATION_ALL_CHECK_CHANGED: {
      const updatedItems = state.items.map(i => ({
        ...i,
        isChecked: action.isChecked,
      }));
      return {
        ...state,
        allChecked: action.isChecked,
        selectedCount: action.isChecked ? updatedItems.length : 0,
        items: updatedItems,
      };
    }

    case types.INV_BY_LOCATIONS_ITEM_SUBMIT: {
      const updatedItems = state.items.map(
        i =>
          i.id !== action.id
            ? i
            : {
                ...i,
                [action.property]: action.value,
              },
      );
      return {...state, items: updatedItems};
    }

    case types.INV_BY_LOCATION_LOADING:
      return {...state, isLoading: true};

    case types.COPY_INV_TO_LOCATION_LOADING:
      return {...state, copyLoading: true};

    case types.COPY_INV_TO_LOCATION_COMPLETE:
      return {...state, copyLoading: false};

    case types.REMOVE_INV_FROM_LOCATION_LOADING:
      return {...state, deleteLoading: true};

    case types.REMOVE_INV_FROM_LOCATION_COMPLETE:
      return {...state, deleteLoading: false};

    case types.INV_BY_LOCATION_SUMMARY_LOADING:
      return {...state, summary: {}};

    case types.INV_BY_LOCATION_SUMMARY_LOADED:
      return {...state, summary: action.summary};

    case types.MOVE_ITEMS.LOADING:
    case types.MOVE_ITEMS.COMPLETE:
      return {...state, moveLoading: action.payload};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/inventoryByLocationReducer.js